import { RootStore } from '@store';
import { computed, makeObservable, observable } from 'mobx';
import { PurseType } from 'types/enums';

export class Bet {
    private readonly rootStore: RootStore;

    @observable
    private _amount: number;

    @observable
    private _currency: PurseType;

    @observable
    private _isMyBet: boolean;

    constructor(rootStore, amount?: number, currency?: PurseType, userId?: string) {
        makeObservable(this);
        this.rootStore = rootStore;
        this._amount = amount ?? 0;
        this._currency = currency ?? PurseType.USD;
        this._isMyBet = userId ? (this.rootStore.userStore.id ? userId === this.rootStore.userStore.id : true) : false;
    }

    @computed
    private get _convertedCurrency() {
        const currency = this.rootStore.userStore.currency;
        return currency === PurseType.DEMO ? PurseType.USD : currency;
    }

    @computed
    private get _currencies() {
        return this.rootStore.userStore.currencies;
    }

    @computed
    public get convertedAmountUSD() {
        if (this._currency === PurseType.DEMO) return 0;
        return (this._amount / this._currencies[this._currency]) * this._currencies[PurseType.USD];
    }

    @computed
    public get convertedAmount() {
        if (this._currency === PurseType.DEMO) return this._amount;
        if (this._currencies[this._convertedCurrency] && this._currencies[this._currency]) {
            return (this._amount / this._currencies[this._currency]) * this._currencies[this._convertedCurrency];
        }
        return this._amount;
    }

    @computed
    public get convertedCurrency() {
        return this._currency === PurseType.DEMO ? PurseType.DEMO : this._convertedCurrency;
    }

    @computed
    public get amount() {
        return this._isMyBet ? this._amount : this.convertedAmount;
    }

    @computed
    public get currency() {
        return this._isMyBet
            ? this._currency
            : this._currency === PurseType.DEMO
            ? this._currency
            : this._convertedCurrency;
    }
}
